import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(@Inject(PLATFORM_ID) private platformId: string) { }

  /**
   * Clears the token from the local storage.
   */
  signOut(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }

  /**
   * Saves the access token to the local storage.
   * @param token The access token to be saved
   */
  public saveToken(token: string): void {
    if (isPlatformBrowser(this.platformId)) {
      const tokenAux: { jwt?: string, refresh_token: string } = JSON.parse(localStorage.getItem('token') || '{}');
      tokenAux.jwt = token;
      localStorage.setItem('token', JSON.stringify(tokenAux));
    }
  }

  /**
   * Retrieves the access token from the local storage.
   * @returns The access token or null if not found
   */
  public getToken(): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(localStorage.getItem('token') || '{}').jwt;
    }
    return null;
  }

  /**
   * Saves the refresh token to the local storage.
   * @param token The refresh token to be saved
   */
  public saveRefreshToken(token: string): void {
    if (isPlatformBrowser(this.platformId)) {
      const tokenAux: { jwt?: string, refresh_token: string } = JSON.parse(localStorage.getItem('token') || '{}');
      tokenAux.refresh_token = token;
      localStorage.setItem('token', JSON.stringify(tokenAux));
    }
  }

  /**
   * Retrieves the refresh token from the local storage.
   * @returns The refresh token or null if not found
   */
  public getRefreshToken(): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(localStorage.getItem('token') || '{}').refresh_token;
    }
    return null;
  }
}
